// extracted by mini-css-extract-plugin
export var box = "_6y-1";
export var checkboxRow = "_6y-8";
export var checked = "_6y-2";
export var descriptionSpacer = "_6y-a";
export var disabled = "_6y-3";
export var icon = "_6y-6";
export var input = "_6y-0";
export var labelSpacer = "_6y-9";
export var medium = "_6y-5";
export var small = "_6y-4";
export var text = "_6y-7";